module.exports = __webpack_public_path__ + "img/avatar-s-16.037d5bcb.jpg";